"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var core_1 = require("@material-ui/core");
var customRadioButtonStyles_1 = require("./customRadioButtonStyles");
exports.CustomRadioButton = function (_a) {
    var formData = _a.formData;
    var styles = customRadioButtonStyles_1.default();
    var value = formData.value, id = formData.id, onChange = formData.onChange, enumOptions = formData.options.enumOptions, schema = formData.schema, label = formData.label;
    var _b = react_1.useState(value), selectedValue = _b[0], setSelectedValue = _b[1];
    var handleChange = react_1.useCallback(function (e) {
        setSelectedValue(e.target.value);
        onChange(e.target.value);
    }, []);
    var radioButtons = enumOptions.map(function (option, index) {
        var _a;
        return (<Box_1.default className={styles.radioButtonContainer} key={index}>
      <core_1.Radio color={'primary'} id={id} checked={selectedValue === option.value} value={option.value} size={'small'} onChange={handleChange} data-test={"radioButton:" + option.value} name={option.value} classes={{
            root: styles.root,
        }}/>
      <Box_1.default className={styles.labelContainer}>
        <core_1.Typography variant={'body2'} data-test={"text:enquiryForm:" + option.value}>
          {option.label}
        </core_1.Typography>
        {((_a = schema) === null || _a === void 0 ? void 0 : _a.disclaimers) && (<core_1.Typography className={styles.disclaimer} data-test={"text:enquiryForm:" + option.value + ":disclaimer"}>
            {schema.disclaimers[option.value]}
          </core_1.Typography>)}
      </Box_1.default>
    </Box_1.default>);
    });
    return (<>
      {label && <core_1.FormLabel className={styles.title}>{label}</core_1.FormLabel>}
      <core_1.RadioGroup className={styles.radioButtonGroup}>{radioButtons}</core_1.RadioGroup>
    </>);
};
exports.default = exports.CustomRadioButton;
